import React, {useEffect, useState}from "react";
import './Medidas.css';
import { Tabs, message } from "antd";
import { Redirect } from 'react-router';
import Boletas from "../../components/MedidasSeguridad/ModificarBoletas";
import Liquido from "../../components/MedidasSeguridad/ModificarLiquido";
import Actas from "../../components/MedidasSeguridad/ModificarActa";


const { TabPane } = Tabs;

class Medidas extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {

        };

    }
    
    componentDidMount() { 
//console..log("props reporte", this.props)
    }




    render() {
        if (this.state.redirect) {
            return <Redirect push to="/seguridad/verificaciones" />;
        }

        return (
           
            <div>
                <h1 className="titulo-main-reportes">Medidas de seguridad</h1>
                <label className="texto-14-adjudicacion">Los datos con ( <label className="rojo-adjudicacion">*</label> ) son requeridos.</label>
           
                {localStorage.getItem('ID_ESTADO_SELECCIONADO') === 'null' 
                    ? message.warning('Favor de seleccionar una entidad en el menú del proceso electoral')
                    :<Tabs defaultActiveKey="1" tabPosition="top" >

                        <TabPane tab="Boletas" key="1">
                            <div className="reporte">
                                <Boletas opcion={1}  
                                idTipoDocumentacion={3}
                                idArticulo={514}
                                numVerificacion={1} />
                            </div>
                        </TabPane>
                        <TabPane tab="Actas" key="2">
                            <div className="reporte">
                                <Actas opcion={2} 
                                idTipoDocumentacion={3}
                                idArticulo={514}
                                numVerificacion={1}/>
                            </div>
                        </TabPane>
                        {this.props.user.infoMenu.detalleSelec.ambitoProceso==="L" &&
                        <TabPane tab="Líquido indeleble" key="3">
                            <div className="reporte">
                                <Liquido opcion={3} 
                                idTipoDocumentacion={3}
                                idArticulo={514}
                                numVerificacion={2}/>
                            </div>
                        </TabPane>
                        
                        }


                    </Tabs>
                }
            </div>
        );
    }
}

export default Medidas;